import React from 'react';
import { get_dynamic_styles } from '../../constant/DynamicStyles';
import { useSelector } from 'react-redux';
import { userSelector } from '../../store/feature/user/userSlice';

const UserProfileImage = ({ data, styles, user }) => {
  const { user_details } = useSelector(userSelector);

  return (
    <div className="" style={get_dynamic_styles(styles?.main_styles)}>
      {(user_details?.profile_pic || data?.default_image) && (
        <img
          style={get_dynamic_styles(styles?.image_styles)}
          src={
            user?.profile_pic ||
            user_details?.profile_pic ||
            data?.default_image
          }
          alt="image"
        />
      )}
    </div>
  );
};

export default UserProfileImage;
